var LoadMore_Handler = {

    init: function(){
        let elem = document.querySelector('.grid-list-load-more');
        let infScroll = new InfiniteScroll( elem, {
        // options
        path: '.pagination__next',
        append: '.infinite-load-more-item',
        history: false,
        button: '.btn-load-more',
});
    },
}

$(document).ready(function(){
    if(document.querySelectorAll(".grid-list-load-more").length > 0){

        LoadMore_Handler.init();
    }
})